import React from 'react';

/**
 * VideoGlow
 *
 * Wraps a video player / thumbnail and paints a subtle, image-derived ambient
 * glow behind it using the SAME poster or thumbnail image (see videoGlow.css).
 *
 * Pass the exact poster/thumbnail URL already used by the player. When no
 * poster is available the wrapper renders without a glow so the video keeps
 * its current appearance - we never invent a colour or borrow another image.
 *
 * Home Building Hub YouTube embeds deliberately do NOT use this wrapper.
 */
export const VideoGlow = ({ poster, className = '', style, children }) => {
  const mergedStyle = poster
    ? { '--bp-video-glow-img': `url("${poster}")`, ...style }
    : style;
  return (
    <div className={`bp-video-glow ${className}`} style={mergedStyle}>
      {children}
    </div>
  );
};

export default VideoGlow;
